<p-dialog header="Creazione Subappalto" styleClass="accrediti-dialog" [focusOnShow]="false" (visibleChange)="onClose()" [(visible)]="visible" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '70vw' }">
    <form class="accrediti-form flex flex-col gap-6" [formGroup]="formSubappalto">

        <div class="w-full flex flex-col">            
            <label>* Ragione Sociale</label>
            <input type="text" pInputText formControlName="ragione_sociale" name="ragione_sociale" id="ragione_sociale" required />
            @if (formSubappalto.get('ragione_sociale')?.hasError('required') && (formSubappalto.get('ragione_sociale')?.dirty || formSubappalto.get('ragione_sociale')?.touched)) { <small class="text-red-600 block mt-4 font-medium">La Ragione Sociale è obbligatoria!</small>}            
        </div>

        <div class="flex lg:flex-row flex-col gap-6">
            <div class="lg:w-1/2 w-full">
                <label>* Partita IVA / Codice Fiscale</label>
                <input type="text" pInputText formControlName="piva" name="piva" id="piva" required />
                @if (formSubappalto.get('piva')?.hasError('required') && (formSubappalto.get('piva')?.dirty || formSubappalto.get('piva')?.touched)) { <small class="text-red-600 block mt-4 font-medium">La P.Iva / Codice Fiscale è obbligatoria!</small>}
            </div>
            <div class="lg:w-1/2 w-full">
                <label>* Attività svolta</label>
                <input type="text" pInputText formControlName="attivita" name="attivita" id="attivita" required />
                @if (formSubappalto.get('attivita')?.hasError('required') && (formSubappalto.get('attivita')?.dirty || formSubappalto.get('attivita')?.touched)) { <small class="text-red-600 block mt-4 font-medium">L'Attività è obbligatoria!</small>}
            </div>
        </div>
        

        <div class="w-full flex items-center">
            <p-checkbox formControlName="responsabilita" inputId="responsabilita" name="responsabilita" value="responsabilita" />
            <label for="responsabilita" class="ml-2"> * Opera sotto la responsabilità della Compagnia / Ditta principale </label>
        </div>
        
        <div class="doc-list">
            <div class="doc-missing"
                [class.crit]="evento?.obbligatorieta && !formSubappalto.get('visura_camerale')?.value"
                [class.ok]="!!formSubappalto.get('visura_camerale')?.value">
                <div class="doc-missing-info">
                    <div class="doc-info">
                        <strong>{{ !evento?.obbligatorieta ? 'Visura camerale subappaltatore' : 'Visura camerale subappaltatore *' }}</strong>
                        <span class="doc-meta" [class.crit]="evento?.obbligatorieta && !formSubappalto.get('visura_camerale')?.value">
                            {{ formSubappalto.get('visura_camerale')?.value ? 'file selezionato' : (evento?.obbligatorieta ? 'non caricato · obbligatorio' : 'non caricato') }}
                        </span>
                    </div>
                </div>
                <app-file-upload #uploadVisuraCamerale [form]="formSubappalto" [control]="'visura_camerale'" [label]="''" [multiple]="false" [critical]="!!evento?.obbligatorieta && !formSubappalto.get('visura_camerale')?.value" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
            </div>
            <div class="doc-missing"
                [class.crit]="evento?.obbligatorieta && !formSubappalto.get('pos')?.value"
                [class.ok]="!!formSubappalto.get('pos')?.value">
                <div class="doc-missing-info">
                    <div class="doc-info">
                        <strong>{{ !evento?.obbligatorieta ? 'POS o dichiarazione sostitutiva' : 'POS o dichiarazione sostitutiva *' }}</strong>
                        <span class="doc-meta" [class.crit]="evento?.obbligatorieta && !formSubappalto.get('pos')?.value">
                            {{ formSubappalto.get('pos')?.value ? 'file selezionato' : (evento?.obbligatorieta ? 'non caricato · obbligatorio' : 'non caricato') }}
                        </span>
                    </div>
                </div>
                <app-file-upload #uploadPos [form]="formSubappalto" [control]="'pos'" [label]="''" [multiple]="false" [critical]="!!evento?.obbligatorieta && !formSubappalto.get('pos')?.value" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
            </div>
            <div class="doc-missing"
                [class.crit]="evento?.obbligatorieta && !formSubappalto.get('autocertificazione')?.value"
                [class.ok]="!!formSubappalto.get('autocertificazione')?.value">
                <div class="doc-missing-info">
                    <div class="doc-info">
                        <strong>{{ !evento?.obbligatorieta ? 'DVR' : 'DVR *' }}</strong>
                        <span class="doc-meta" [class.crit]="evento?.obbligatorieta && !formSubappalto.get('autocertificazione')?.value">
                            {{ formSubappalto.get('autocertificazione')?.value ? 'file selezionato' : (evento?.obbligatorieta ? 'non caricato · obbligatorio' : 'non caricato') }}
                        </span>
                    </div>
                </div>
                <app-file-upload #uploadAutocertificazione [form]="formSubappalto" [control]="'autocertificazione'" [label]="''" [multiple]="false" [critical]="!!evento?.obbligatorieta && !formSubappalto.get('autocertificazione')?.value" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
            </div>
        </div>

        <div class="acc-actions">
            <button type="button" class="acc-btn acc-btn-ghost" (click)="onClose();">Annulla</button>
            <button type="button" class="acc-btn acc-btn-primary" [disabled]="!formSubappalto.valid" (click)="onAdd()">Crea</button>            
        </div>
    </form>
    
</p-dialog>